import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the HelpPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-help',
  templateUrl: 'help.html',
})
export class HelpPage {

  shownGroup = null;

  helpentries = [
   
    { title: "Generator: Refill Diesel", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." },
    { title: "Generator: Switch On/Off", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." },
    { title: "Kernel Mill: Operate Kernel Cracker", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." },
    { title: "Kernel Mill: Operate Kernel Press", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." },
    { title: "Palm Oil Mill: Operate Tresher", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." },
    { title: "Palm Oil Mill: Operate Press", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." },
    { title: "Weighbridge: Weigh Vehicle", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." },
    { title: "Weighbridge: Change language", description: "To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed. To Be Completed." }
  ];

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HelpPage');
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
        this.shownGroup = null;
    } else {
        this.shownGroup = group;
    }
  };

  isGroupShown(group) {
      return this.shownGroup === group;
  };

}


// WEBPACK FOOTER //
// ./src/pages/help/help.ts